import Vue from "vue";

import { RoundRobinApiSelector } from "../select-api/select_api";

export class RestResource {
  static __writeBaseAPIs = process.env.VUE_APP_ROOT_API_WRITE.split(";").map(
    (e) => e.replace(/\/+$/, "")
  );
  static __readBaseAPIs = process.env.VUE_APP_ROOT_API.split(";").map((e) =>
    e.replace(/\/+$/, "")
  );

  static RestResourceApiWrite = new RoundRobinApiSelector(
    RestResource.__writeBaseAPIs
  );
  static RestResourceApiRead = new RoundRobinApiSelector(
    RestResource.__readBaseAPIs
  );

  static basePath = "";

  static get ApiWrite() {
    return RestResource.RestResourceApiWrite.get() + this.basePath;
  }

  static get ApiRead() {
    return RestResource.RestResourceApiRead.get() + this.basePath;
  }

  static index = function (params) {
    if (!this.INDEX) throw new Error("INDEX not implemented");
    return Vue.http.get(this.ApiRead, { params });
  };
  static get = function (params) {
    if (!this.GET) throw new Error("GET not implemented");
    return Vue.http.get(`${this.ApiRead}/${params.id}`, { params });
  };
  static store = function (params) {
    if (!this.STORE) throw new Error("STORE not implemented");
    return Vue.http.post(this.ApiWrite, params);
  };
  static update = function (params) {
    if (!this.UPDATE) throw new Error("UPDATE not implemented");
    return Vue.http.put(`${this.ApiWrite}/${params.id}`, params);
  };
  static delete = function (params) {
    if (!this.DELETE) throw new Error("DELETE not implemented");
    return Vue.http.delete(`${this.ApiWrite}/${params.id}`, { body: params });
  };
}

export class ModelResource extends RestResource {
  static basePath = "/models";
  static INDEX = true;
  static GET = true;

  static getPost = ({ modelID, postID }) =>
    Vue.http.get(`${ModelResource.ApiRead}/${modelID}/posts/${postID}`);
}

export class PostLikeResource extends RestResource {
  static basePath = "/post_likes";

  static toggleLike = ({ postID }) =>
    Vue.http.post(
      PostLikeResource.ApiWrite,
      {},
      { params: { post_id: postID } }
    );
}

export class PostOptionResource extends RestResource {
  static basePath = "/post_options";

  static report({ postId, modelId, reason, userEmail }) {
    return Vue.http.post(
      `${PostOptionResource.ApiWrite}/report`,
      {},
      { params: { postId, modelId, reason, userEmail } }
    );
  }
}

export class WebstarsResource extends RestResource {
  static basePath = "";

  static get ApiWrite() {
    return process.env.VUE_APP_WEBSTARS_PANEL_URL;
  }

  static LoginURL({ model_id, token }) {
    // return `${WebstarsResource.ApiWrite}/api/fetch-token-login?model_id=${model_id}&token=${token}`;
    return `${WebstarsResource.ApiWrite}/fetch-token-login?model_id=${model_id}&token=${token}`;
  }

  static LoginURLWithRedirect({ model_id, token }) {
    return `${WebstarsResource.ApiWrite}/login?model_id=${model_id}&token=${token}`;
  }

  static LogoutURL() {
    // return `${WebstarsResource.ApiWrite}/fetch-logout`;
    return `${WebstarsResource.ApiWrite}/logout`;
  }

  static RegisterUrl() {
    return `${WebstarsResource.ApiWrite}/register`;
  }

  static HomeUrl() {
    return `${WebstarsResource.ApiWrite}`;
  }
}

export class ClaimResource extends RestResource {
  static basePath = "/claim";

  static generalClaim(
    { email, username, country, document, card_company, card_number, claim, model_id },
    files
  ) {
    const formData = new FormData();
    const headers = { "Content-Type": "multipart/form-data" };

    formData.append("email", email);
    formData.append("username", username);
    formData.append("country", country);
    formData.append("document", document);
    formData.append("card_company", card_company);
    formData.append("card_number", card_number);
    formData.append("claim", claim);
    formData.append("model_id", model_id);

    if (
      files &&
      typeof files === "object" &&
      typeof files[Symbol.iterator] === 'function' &&
      files.length > 0
    ) {
      console.log("files");

      for (let i = 0; i < files.length; i++) {
        formData.append("files[]", files[i]);
      }
    }

    return Vue.http.post(ClaimResource.ApiWrite, formData, { headers });
  }

  static reportModel(modelId, data, files) {
    const formData = new FormData();
    const headers = { "Content-Type": "multipart/form-data" };

    formData.append("name", data.name);
    formData.append("claim", data.claim);
    formData.append("email", data.email);
    formData.append("recaptcha", data.recaptcha);

    if (
      files &&
      typeof files === "object" &&
      typeof files[Symbol.iterator] === 'function' &&
      files.length > 0
    ) {
      for (let i = 0; i < files.length; i++) {
        formData.append("files[]", files[i]);
      }
    }

    return Vue.http.post(
      `${ClaimResource.ApiWrite}/model/${modelId}`, 
      formData, 
      { headers }
    );
  }
}

export class CommentsResource extends RestResource {
  static basePath = "/comments";

  static getComments(postId) {
    return Vue.http.get(`${CommentsResource.ApiRead}/${postId}`);
  }

  static getReplies(postId, commentId) {
    return Vue.http.get(`${CommentsResource.ApiRead}/${postId}/reply/${commentId}`);
  }

  static getCommentsByPaginatorLink(link) {
    return Vue.http.get(link);
  }

  static sendComment(postId, comment, commentId = null) {
    return Vue.http.post(`${CommentsResource.ApiWrite}/store`, {
      post_id: postId,
      message: comment,
      comment_id: commentId,
    });
  }

  static deleteComment(commentId) {
    return Vue.http.delete(`${CommentsResource.ApiWrite}/${commentId}`);
  }
}

export class UserResource extends RestResource {
  static basePath = "/user";

  // static changeProfilePicture({ file }) {
  //   const formData = new FormData();
  //   formData.append("profile_pic", file);
    
  //   return Vue.http.post(
  //     `${UserResource.ApiWrite}/profile_pic`, 
  //     formData,
  //   );
  // }

  /*
  * Get the profile picture URL from the raw path.
  * This is not a REST API call.
  */
  // static getProfilePicURL(rawPath) {
  //   return `${UserResource.ApiRead}/${rawPath}`;
  // }
}

export class ChatResource extends RestResource {
  static basePath = "/chat";

  static getHomeUrl() {
    return Vue.http.post(`${ChatResource.ApiRead}/home`);
  }
  static getToken(roomId) {
    return Vue.http.post(`${ChatResource.ApiRead}/get_token`,{"room_id" : roomId}
    );
  }
}

export class BannerResource extends RestResource {
  static basePath = "/banner";

  static getHomeBanner() {
    return Vue.http.get(`${BannerResource.ApiRead}/home`);
  }
}
